<template>
  <div class="main-header p-4">
    <div class="flex justify-between items-center">
      <!-- 전체 거래 시작 / 중지 / 매도 버튼 -->
      <div class="flex space-x-4 items-center">
        <span class="text-lg font-bold">전체 코인 설정</span>
      </div>
      <!-- 전체 매수 중지 / 강제 매도 설정 -->
      <div class="flex space-x-4 items-center"></div>
      <!-- long, short 전환-->
      <div class="flex space-x-4">
        <button
          :class="{ 'bg-green-500': GT_IS_LONG, 'bg-gray-700': !GT_IS_LONG }"
          @click="setLong('long')"
          class="px-4 py-2 rounded text-white font-bold"
        >
          Long
        </button>
        <button
          :class="{ 'bg-red-500': !GT_IS_LONG, 'bg-gray-700': GT_IS_LONG }"
          @click="setLong('short')"
          class="px-4 py-2 rounded text-white font-bold"
        >
          Short
        </button>
      </div>
    </div>
  </div>
  <div class="main-header px-4 py-2">
    <div class="flex space-x-4 items-center justify-between">
      <div class="flex justify-start items-start space-x-4">
        <span class="text-md font-bold">현재 유저 USDT</span>
        <span
          ><b>총 자산</b> :
          {{ ASSET_USDT.balance.toLocaleString("en-US") }} USDT</span
        >
        <span
          ><b>거래 가능 자산</b> :
          {{ ASSET_USDT.availableBalance.toLocaleString("en-US") }} USDT</span
        >
      </div>
      <span class="font-sm">
        {{ new Date(ASSET_USDT.updateTime).toLocaleTimeString("ko-KR") }}
        updated</span
      >
    </div>
  </div>
  <ConfigModal
    v-if="modalInfo.isModalOpen"
    :modalType="modalInfo.type"
    :forceStop="getCurrentForceStop(GT_IS_LONG)"
    :forceSell="getCurrentForceSell(GT_IS_LONG)"
    :isMobile="modalInfo.isMobile"
    @close="closeModal"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ConfigModal from "./modal/ConfigModal.vue";
import { storeName } from "@/global/variable";

const assetStore = "assetStore";
const coreStore = "coreStore";
const stopStore = "stopStore";

export default {
  name: "AppHeader",
  components: {
    ConfigModal,
  },
  data() {
    return {
      modalInfo: {
        isModalOpen: false,
        type: "", // sell , stop
        isMobile: false,
      },
      // modalTitle: "",
      // modalType: "",
      // isModalOpen: false,
    };
  },
  mounted() {
    // this.$store.dispatch(`stopStore/AT_LOAD_STOP_BOTH`, { symbol: "GLOBAL" });
  },
  computed: {
    ...mapGetters(assetStore, ["ASSET_USDT"]),
    ...mapGetters(coreStore, ["GT_IS_LONG"]),
    ...mapGetters(stopStore, [
      "GET_STOP_GLOBAL_LONG",
      "GET_STOP_GLOBAL_SHORT",
      "GET_SELL_GLOBAL_LONG",
      "GET_SELL_GLOBAL_SHORT",
    ]),
  },
  methods: {
    ...mapMutations(coreStore, ["MU_UPDATE_TYPE"]),
    ...mapActions(storeName.tradeHistory, ["AT_GET_CUM_LIST"]),

    setLong(value) {
      this.MU_UPDATE_TYPE(value);
      this.AT_GET_CUM_LIST();
    },

    /**
     * 전체 설정 모달 오픈
     *
     * @param modalType {String} stopBuy | forceClose
     */
    openModal(modalType) {
      this.modalInfo = {
        ...this.modalInfo,
        isModalOpen: true,
        type: modalType,
      };
    },
    /**
     * 전체 설정 모달 종료
     */
    closeModal() {
      this.modalInfo = {
        ...this.modalInfo,
        isModalOpen: false,
        type: "",
      };
    },
    // 현재 포지션의 global 강제 매수 중지 객체 조회
    getCurrentForceStop(isLong) {
      return isLong ? this.GET_STOP_GLOBAL_LONG : this.GET_STOP_GLOBAL_SHORT;
    },
    // 현재 포지션의 global 강제 매도 객체 조회
    getCurrentForceSell(isLong) {
      return isLong ? this.GET_SELL_GLOBAL_LONG : this.GET_SELL_GLOBAL_SHORT;
    },
  },
};
</script>

<style>
.main-header {
  background-color: #fff;
}
</style>
